// Stuck here temp

/**
 * Config service
 */

// Explicitly global: every other module reads a bare `CONFIG`, and a bundler
// would otherwise scope this to config.js alone.
window.CONFIG = (function () {
  var settings = {
    urls: {
      dashboard: {
        index: '/', // root
      },
      members: {
        api: '/api/1/members/:id',
        all: '/members',
        add: '/members/add',
        edit: '/members/:id/edit',
        history: '/members/:id/history',
        // 'import': '/members/import',
        updreqs: '/updreqs',
        export: '/member_export/:filter',
        deleted: '/members/removed',
        applications: '/members/applications',
        // TODO: redirs for /members/{removed,applications}/:id/{edit,history}
        bulkedit: '/members/bulkedit/:filter',
      },
      fields: {
        api: '/api/1/fields/:id',
        all: '/config/fields',
        add: '/config/fields/add',
        edit: '/config/fields/:id',
      },
      session: {
        api: '/api/1/session/:action',
        login_external: '/@login',
        logout_external: '/@logout',
      },
      settings: {
        api: '/api/1/settings/:id',
        edit_eclaim: '/config/settings_eclaim',
        edit: '/config/settings',
        edit_membercard: '/config/settings_membercard',
        mandate: '/config/mandate',
        security: '/config/security',
      },
      log: {
        api: '/api/1/log/:id',
        all: '/log',
        transactions: '/log/transactions',
        receipts: '/log/receipts',
        view: '/log/:id',
        transaction_report_xls: '/log/transaction_report_xls',
      },
      lang: {
        change: '/config/lang/:locale',
      },
      invoices: {
        api: '/api/1/invoices/:id',
        all: '/invoices',
        view: '/invoices/:id',
        view_one: '/invoices/:id/person/:person_id',
        create: '/invoices/new',
        report: '/invoices/report',
        download_report: '/invoice_report/xls',
        download_refs: '/invoice_report/refs',
        sales_invoice_list: '/invoices/sales_invoice_list',
        sales_invoice_list_xls: '/invoice_report/sales_invoice_list_xls',
        sales_invoice_list_pdf: '/invoice_report/sales_invoice_list_pdf',
        accounts_receivable: '/invoices/accounts_receivable',
        accounts_receivable_xls: '/invoice_report/accounts_receivable_xls',
        accounts_receivable_pdf: '/invoice_report/accounts_receivable_pdf',
        reminder: '/invoices/reminder/:id',
        addrecips: '/invoices/new/:id',
        download_pdf: '/invoices/download_pdf/:id.pdf',
      },
      invoicereminders: {
        view: '/invoices/:id', // For member history
      },
      messages: {
        api: '/api/1/messages/:id',
        letter_preview: '/msg/letter-preview/:message_id.:file_extension',
        letter_preview_page: '/msg/letter-preview/:message_id/:page.:file_extension',
        show: '/msg/show/:media/:id',
      },
      announcements: {
        api: '/api/1/announcements/:id',
        all: '/announcements',
        view: '/announcements/:id',
        create: '/announcements/new',
      },
      membercard: {
        api: '/api/1/membercard/:id',
        all: '/membercard',
        view: '/membercard/:id',
        create: '/membercard/new',
      },
      expenseclaim: {
        api: '/api/1/expenseclaim/:id',
        all: '/expenseclaim',
        archive: '/expenseclaim/archive',
        view: '/expenseclaim/view/:person_id/:person_account_number',
        edit: '/expenseclaim/:id',
        download_pdf: '/claim_download_pdf/:person_id/:person_account_number/:status/:timestamp',
      },
      updreqs: {
        api: '/api/1/updreqs/:id',
        all: '/updreqs',
        view: '/updreqs/:id',
        create: '/updreqs/new',
        edit_me_h: '/edit_me_h/:hash',
        edit_me_s: '/edit_me_s',
        get_edit_links: '/updreqs/get_edit_links',
      },
      supersearch: {
        list: '/search/:type/:term',
      },
      mooney: {
        api: '/api/1/mooney/:id',
        method: '/m/:id/method',
        charge: '/m/:id/charge',
        failure: '/m/failure',
      },
      importer: {
        api: '/api/1/importer/:id',
        all: '/members/imports/all',
        importer: '/members/import',
      },
      groups: {
        api: '/api/1/groups/:id',
        all: '/config/groups',
        add: '/config/groups/add',
        edit: '/config/groups/:id',
      },
      balance: {
        api: '/api/1/balance/:id',
        buy: '/balance/buy',
        thanks: '/balance/thanks',
        // earn: '/balance/earn',
        send_email: '/balance/send_email',
      },
      docs: {
        api: '/api/1/docs/:id',
      },
    },
  }

  var byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1')
    s = s.replace(/^\./, '')
    var a = s.split('.')
    while (a.length) {
      var n = a.shift()
      if (n in o) {
        o = o[n]
      } else {
        return
      }
    }
    return o
  }

  var all_urls = {}
  jQuery.each(settings.urls, function (module, urls) {
    all_urls[module] = {}
    jQuery.each(urls, function (op, url) {
      all_urls[module][op] = function () {
        // make a safe copy of the arguments "array"
        var args = [].slice.call(arguments)

        var u = url.replace(/:\w+/g, function (s) {
          return args.length ? args.shift() : s
        })

        if (args.length) {
          throw 'Too many parameters for url ' + url + ' (CONFIG.url.' + module + '.' + op + ')'
        }

        return window.a4base + u
      }
    })
  })

  return {
    get: function (prop) {
      return byString(settings, prop)
    },
    // Return the combined API path
    api: function (prop) {
      // return settings.api.path + '/' + settings.api.version + byString(settings, 'urls.' + prop + '.api');
      return window.a4base + byString(settings, 'urls.' + prop + '.api')
    },
    url: all_urls,
    //function(prop, path, params) {
    //  path = typeof path !== 'undefined' ? path : 'all'; //Time saver for when we want the most common link to default page
    //  params = typeof params !== 'undefined' ? '/' + params : '';
    //  return window.a4base + byString(settings, 'urls.' + prop + '.' + path) + params;
    //}
  }
})()
